import { render, staticRenderFns } from "./couponPoster.vue?vue&type=template&id=b859b432&scoped=true"
import script from "./couponPoster.vue?vue&type=script&lang=js"
export * from "./couponPoster.vue?vue&type=script&lang=js"
import style0 from "./couponPoster.vue?vue&type=style&index=0&id=b859b432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b859b432",
  null
  
)

export default component.exports